export const buildDepartments = departments =>
    departments.map((department) => buildDepartment(department));

const buildDepartment = (department) => ({
    ...department,
})

export const channelOptions = [
    { label: 'Canal de voz', value: 'voiceChannel' },
    { label: 'Chile autos', value: 'chileAutos' },
    { label: 'Email', value: 'email' },
    { label: 'Facebook', value: 'facebook' },
    { label: 'Formulario Web', value: 'web' },
    { label: 'Instagram', value: 'instagram' },
    { label: 'Linze', value: 'linze' },
    { label: 'LinkedIn', value: 'linkedin' },
    { label: 'Mercado Libre', value: 'meli' },
    { label: 'Telegram', value: 'telegram' },
    { label: 'Twitter', value: 'twitter' },
    { label: 'Webchat', value: 'webchat' },
    { label: 'Whatsapp', value: 'whatsapp' }
];

export const typeOptions = [
    { label: 'Comercial', value: 'Comercial' },
    { label: 'Cooperativas', value: 'Cooperativas' },
    { label: 'Consulta', value: 'Consulta' },
    { label: 'Notificación', value: 'Notificación' },
    { label: 'Publicación cortes', value: 'Publicación cortes' },
    { label: 'Queja', value: 'Queja' },
    { label: 'Reclamo', value: 'Reclamo' },
    { label: 'Sistema', value: 'Sistema' },
    { label: 'Spam', value: 'Spam' },
    { label: 'Usina molet', value: 'Usina molet' },
    { label: 'Otros', value: 'Otros' },
];

export const typeOptionsMundoCredito = [
    { label: 'Consulta', value: 'Consulta'},
    { label: 'Prepago', value: 'Prepago'},
    { label: 'Reclamo', value: 'Reclamo'},
    { label: 'Solicitud', value: 'Solicitud'}
];

export const typeOptionsMaviGPS = [
    { label: 'Consulta', value: 'Consulta'},
    { label: 'Incidente', value: 'Incidente'},
    { label: 'Masivo', value: 'Masivo'},
    { label: 'Requerimiento', value: 'Requerimiento'}
];

export const reasonOptions = [
    { label: 'ABM', value: 'ABM' },
    { label: 'Acceso Denegado', value: 'Acceso Denegado' },
    { label: 'Atención', value: 'Atención' },
    { label: 'Corte', value: 'Corte' },
    { label: 'Datos', value: 'Datos' },
    { label: 'Facturación', value: 'Facturación' },
    { label: 'Facturación Evoltis', value: 'Facturación Evoltis' },
    { label: 'Gestiones comerciales', value: 'Gestiones comerciales' },
    { label: 'Mail', value: 'Mail' },
    { label: 'Negativos', value: 'Negativos' },
    { label: 'Pagos', value: 'Pagos' },
    { label: 'Positivos', value: 'Positivos' },
    { label: 'Problema General', value: 'Problema General' },
    { label: 'RETUIT', value: 'RETUIT' },
    { label: 'RRPP', value: 'RRPP' },
    { label: 'Tecnica', value: 'Tecnica' },
    { label: 'Otros', value: 'Otros' },
];

export const reasonOptionsMundoCredito = [
    {label: 'Alzamientos', value: 'Alzamientos'},
    {label: 'Certificados', value: 'Certificados' },
    {label: 'Cuotas vencidas', value: 'Cuotas vencidas'},
    {label: 'Información de su cuenta', value:  'Información de su cuenta'},
    {label: 'Seguros', value: 'Seguros' },
    {label: 'Otras', value: 'Otras'},
]

export const subreasonsOptionsMundoCredito = [
    {label: 'Quiero conocer mi deuda', value: 'Quiero conocer mi deuda'},
    {label: 'Quiero prepagar', value: 'Quiero prepagar'},
    {label: 'Quiero renovar', value: 'Quiero renovar'},
]

export const reasonOptionsMaviGPS = [
    {label: 'APPs Clientes', value: 'APPs Clientes'},
    {label: 'Bloqueo', value:  'Bloqueo'},
    {label: 'Cambio de clave', value:  'Cambio de clave'},
    {label: 'Cambio de equipo', value: 'Cambio de equipo' },
    {label: 'Cambio de simcard', value: 'Cambio de simcard' },
    {label: 'Capacitación', value: 'Capacitación'},
    {label: 'Correo Bienvenida', value: 'Correo Bienvenida' },
    {label: 'Entel', value: 'Entel'},
    {label: 'GPS no transmite', value: 'GPS no transmite'},
    {label: 'Instalador', value: 'Instalador' },
    {label: 'Integración', value: 'Integración'},
    {label: 'Migración', value: 'Migración'},
    {label: 'Movistar', value:  'Movistar'},
    {label: 'Plataforma Q', value: 'Plataforma Q' },
    {label: 'Renovación', value:  'Renovación'},
    {label: 'Servicio de Notificaciones', value: 'Servicio de Notificaciones' },
    {label: 'Sistema Operador', value: 'Sistema Operador'},
    {label: 'Sistema de Ticket', value: 'Sistema de Ticket'},
    {label: 'SMS', value: 'SMS'},
    {label: 'Telefonía', value: 'Telefonía'},
    {label: 'Transmisión Erronea', value: 'Transmisión Erronea' },
    {label: 'Ubicación', value: 'Ubicación'},
    {label: 'Uso', value: 'Uso'},
];

export const detailOptions = [
    { label: 'Adhesión a OVP', value: 'Adhesión a OVP' },
    { label: 'Adhesión nvo. contrato', value: 'Adhesión nvo. contrato' },
    { label: 'Alumbrado publico', value: 'Alumbrado publico' },
    { label: 'Baja de facturación digital', value: 'Baja de facturación digital' },
    { label: 'Datos comerciales', value: 'Datos comerciales' },
    { label: 'Error de acceso en alguna sección', value: 'Error de acceso en alguna sección' },
    { label: 'Exceso de facturación', value: 'Exceso de facturación' },
    { label: 'Factura', value: 'Factura' },
    { label: 'Factura papel', value: 'Factura papel' },
    { label: 'Falta energia (CORTE)', value: 'Falta energia (CORTE)' },
    { label: 'Impresión', value: 'Impresión' },
    { label: 'Modificación mail OVP', value: 'Modificación mail OVP' },
    { label: 'No llega la factura', value: 'No llega la factura' },
    { label: 'OVP + Factura digital', value: 'OVP + Factura digital' },
    { label: 'Reclamo conexion', value: 'Reclamo conexion' },
    { label: 'Usuario + Contraseña OVP', value: 'Usuario + Contraseña OVP' },
    { label: 'Verificar medidor', value: 'Verificar medidor' },
];

export const priorityOptions = [
    { label: 'Baja', value: 'low' },
    { label: 'Media', value: 'normal' },
    { label: 'Alta', value: 'high' },
];
